import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { ColdSubject } from 'app/core/guards/cold-subject';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { FlowSandbox } from 'app/core/sandboxes/flow.sandbox';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { firstValueFrom, Observable } from 'rxjs';
import * as fromRoot from '..';
import { FlowRestService } from '../../services/rest/flow.rest.service';

/**
 * Guard to async load a flow before following a route
 *
 **/

@Injectable({ providedIn: 'root' })
export class DisputeFlowGuard implements CanActivate, DependencyTreeCanActivate {
  private flowRestService: FlowRestService;
  private store: Store<fromRoot.RootState>;
  private sandbox: FlowSandbox;

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => FlowRestService)) flowRestService, @Inject(forwardRef(() => FlowSandbox)) sandbox) {
    this.store = store;
    this.flowRestService = flowRestService;
    this.sandbox = sandbox;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return new ColdSubject(async () => {
      let result: Observable<boolean>;
      const customer = await this.sandbox.getCustomerForEdit();
      result = this.sandbox.disputeFlow(customer.id, route.paramMap.get('etmOrderNumber'));
      return await firstValueFrom(result);
    });
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'FLOW.CREATE',
    };
  }
}
